import React, { useState } from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import {CheckBox, DriveFileRenameOutline, ArrowBack, TableChart } from '@mui/icons-material';

import CurrentMathReport from './CurrentMathReport';
import EditCheck from './EditCheck';
import MathReportFields from './MathReportTable';

interface ReportsProps {
    setSelectedIndex: (index: number) => void;
  }  

const MathReportMenu: React.FC<ReportsProps> = ({setSelectedIndex}) => {
  const [activeModule, setActiveModule] = useState<'editCheck' | 'currentReport' | 'MathReportFields' | null>('currentReport');

  const handleReportClick = () => {
    setSelectedIndex(3);
  };

  return (
    <Box sx={{ maxWidth: '100%', overflowX: 'auto' }}>

      <Box sx={{ mb: 2, display: 'flex', gap: '10px' }}>
      <Tooltip title="Отчеты" enterDelay={1000} arrow>
          <Button
            variant="contained"
            color="warning"
            onClick={() => handleReportClick()}
            sx={{background: 'darkblue'}}
            startIcon={<ArrowBack />}
          >
            Назад
          </Button>
        </Tooltip>

        <Tooltip title="Просмотр данных мат. отчета" enterDelay={1000} arrow>
          <Button
            variant="contained"
            color="warning"
            onClick={() => setActiveModule('currentReport')}
            startIcon={<DriveFileRenameOutline />}
          >
            Редактировать
          </Button>
        </Tooltip>

        <Tooltip title="Проверка на изменение" enterDelay={1000} arrow>
          <Button
            variant="contained"
            startIcon={<CheckBox />}
            onClick={() => setActiveModule('editCheck')}
          >
            Изменения
          </Button>
        </Tooltip>

        {localStorage.getItem('role') === 'admin' && (
        <Tooltip title="Настройка полей для отображения/редактирования" enterDelay={1000} arrow>
          <Button
            variant="contained"
            color="warning"
            onClick={() => setActiveModule('MathReportFields')}
            sx={{background: 'green'}}
            startIcon={<TableChart />}
          >
            Отображение
          </Button>
        </Tooltip>
      )}
      </Box>

      {activeModule === 'currentReport' && <CurrentMathReport />}
      {activeModule === 'editCheck' && <EditCheck />}
      {activeModule === 'MathReportFields' && <MathReportFields />}

    </Box>
  );
};

export default MathReportMenu;